@if ({ isLoading: loadingService.isSpinnerActive$('loadSpConnection') | async }; as loadingState) { @if (!loadingState.isLoading) {
<coso-replicator-page-header [title]="title"></coso-replicator-page-header>
@if (isRunning) {
<alert type="warning">
  <coso-alert-message>You can only modify the content of this page once the replication process is stopped.</coso-alert-message>
</alert>
} @if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
} @if (structureCreatorError) {
<alert type="warning" [dismissible]="true" (onClose)="structureCreatorError = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="structureCreatorError"></div>
  </coso-alert-message>
</alert>
} @if (successMessage) {
<alert type="success" [dismissible]="true" (onClose)="successMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="successMessage"></div>
  </coso-alert-message>
</alert>
}
<form [formGroup]="formGroup" (ngSubmit)="saveConnection()">
  <div class="card card-cns mb-3">
    <div class="card-header">General</div>
    <div class="card-body">
      <p class="text-muted">
        <small><em>All fields are required unless specified optional</em></small>
      </p>
      <coso-text-input [control]="formGroup.controls.name" [inputText]="formText.name" type="text" [readonly]="isReadOnly"> </coso-text-input>
    </div>
  </div>
  <div class="card card-cns mb-3">
    <div id="header" class="card-header">SharePoint</div>
    <div id="body" class="card-body">
      <p class="text-muted">
        <small><em>All fields are required unless specified optional</em></small>
      </p>
      <coso-sharepoint-connection-form
        [viewMode]="isConfigured ? (isReadOnly ? ViewMode.View : ViewMode.Edit) : ViewMode.Create"
        [isSaaS]="isSaaS"
        [connectionFormGroup]="formGroup.controls.sharePoint"
        [showAzureEndpoint]="false"
        [showIsOnlineOption]="false"
        [showUseDefaultCertificate]="!isFailoverBackupInstance"
        [showGrantType]="true"
        [showApiPermission]="true"
        [supportsExternalAzureAdAppInSaaS]="true"
        [supportsManagedIdentity]="!isSaaS"
      ></coso-sharepoint-connection-form>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-lg-12">
      <div class="d-flex justify-content-between">
        <a class="btn btn-dark" [routerLink]="['/', 'configuration', instanceId, 'connections']"><span class="fa fa-chevron-left mr-1" aria-hidden="true"></span>Back to Connections list</a>
        @if (!isReadOnly) {
        <button type="submit" class="btn btn-primary col-2" [disabled]="formGroup.invalid || (spConnectionHandler.isTestingConnection$ | async)">Save</button>
        }
      </div>
    </div>
  </div>
</form>
} }

<ng-template #validationRef>
  The following settings are not compatible with your new site collection URL and must be removed:
  <ul>
    @for (incompatibility of incompatibilities; track incompatibility) {
    <li>{{ incompatibility }}</li>
    }
  </ul>
  <p>Would you like to remove them and continue?</p>
  <strong class="text-primary">Please note that you will not be able to recover them later.</strong>
</ng-template>
